import React, { useState } from 'react';
import { useDispatch } from 'hooks/store';
import { usePagination } from 'hooks/pagination';
import {
  ProductionItem,
  SeedTicket,
  UserProfile,
} from 'constants/interface';
import { Table } from 'UI';
import {
  getSeedTicketListAction,
} from 'state/slices/productionItem';
import {
  buildRegularProductDisplay,
  buildSimpleQuantityDisplay,
} from 'helpers/order';
import { unwrapResult } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { GetProductionItemList } from 'api/productionItem';
import { formatDate } from 'helpers/utils';
import { SeedTicketStatusEnum } from 'constants/order';
import TableRowAction from './components/TableRowAction';
import TicketDetailsModal from './components/TicketDetailsModal';

const ConfirmedTicketsTab = (): JSX.Element => {
  const dispatch = useDispatch();

  const [incomingTicketList, setIncomingTicketList] = useState<SeedTicket[]>();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isTicketDetailsModalOpen, setTicketDetailsModalOpen] = useState<boolean>(false);
  const [currentActiveRow, setCurrentActiveRow] = useState<number>();

  const fetchIncomingTickets = async (paginationData: GetProductionItemList) => {
    setLoading(true);
    const result = await dispatch(getSeedTicketListAction({
      ...paginationData,
      isPaginated: true,
      status: SeedTicketStatusEnum.CLOSED,
    }));
    setLoading(false);
    const { data } = unwrapResult(result);
    setIncomingTicketList(data);
  };

  const pagination = usePagination<SeedTicket>(
    fetchIncomingTickets,
    {
      initialTotal: incomingTicketList?.length,
    },
  );

  const onDetailsActionClick = (index: number) => {
    setCurrentActiveRow(index);
    setTicketDetailsModalOpen(true);
  };

  const onTicketDetailsModalClosed = () => {
    setTicketDetailsModalOpen(false);
    setCurrentActiveRow(undefined);
  };

  return (
    <>
      {/* <SearchContainer>
        <DatePicker
          allowClear={false}
          defaultValue={dayjs(selectedDate)}
          showTime={false}
          onSelect={(value) => {
            setSelectedDate(value.format());
          }}
        />
      </SearchContainer> */}
      <Table<SeedTicket>
        rowKey="id"
        dataSource={incomingTicketList}
        pagination={pagination.getInternal()}
        loading={isLoading}
        showSorterTooltip={false}
        locale={{
          filterReset: 'Limpar',
          cancelSort: 'Clique para limpar ordenação',
          triggerAsc: 'Clique para ordem crescente',
          triggerDesc: 'Clique para ordem decrescente',
        }}
        // onChange={pagination.onTableChange}
      >
        {/* TODO: add link to order root page? */}
        <Table.Column
          title="Data solicitação"
          key="createdAt"
          dataIndex="createdAt"
          render={(
            createdAt: string,
          ) => formatDate(dayjs(createdAt))}
        />
        <Table.Column
          title="Nº solicitação"
          key="seq"
          dataIndex="seq"
          render={(
            seq: number,
          ) => seq}
        />
        <Table.Column
          title="Produto"
          key="product"
          dataIndex="productionItem"
          render={(
            productionItem: ProductionItem,
          ) => {
            const display = buildRegularProductDisplay(productionItem, {
              quantity: false,
              tray: false,
            });
            return display;
          }}
        />
        <Table.Column
          title="Qtd sementes"
          key="requestQuantity"
          dataIndex="requestQuantity"
          render={(
            requestQuantity: number,
          ) => {
            const display = buildSimpleQuantityDisplay(requestQuantity);
            return display;
          }}
        />
        <Table.Column
          title="Cliente"
          key="client"
          dataIndex="productionItem"
          // filters={Object.values(OrderTypeEnum).map((orderType) => ({
          //   text: OrderTypeDisplayMapping[orderType].name,
          //   value: orderType,
          // }))}
          // filterMultiple={false}
          // filteredValue={orderTypeFilter !== null ? [orderTypeFilter] : null}
          render={(productionItem: ProductionItem) => {
            const displayName = productionItem.orderItem.order.client.name;
            return displayName;
          }}
        />
        <Table.Column
          title="Data semeio prev"
          key="plannedSeedingDate"
          dataIndex="productionItem"
          // filters={Object.values(OrderTypeEnum).map((orderType) => ({
          //   text: OrderTypeDisplayMapping[orderType].name,
          //   value: orderType,
          // }))}
          // filterMultiple={false}
          // filteredValue={orderTypeFilter !== null ? [orderTypeFilter] : null}
          render={(productionItem: ProductionItem) => {
            const display = formatDate(dayjs(productionItem.orderItem.plannedSeedDate));
            return display;
          }}
        />
        <Table.Column
          title="Unidade"
          key="organization"
          dataIndex="productionItem"
          // filters={Object.values(OrderTypeEnum).map((orderType) => ({
          //   text: OrderTypeDisplayMapping[orderType].name,
          //   value: orderType,
          // }))}
          // filterMultiple={false}
          // filteredValue={orderTypeFilter !== null ? [orderTypeFilter] : null}
          render={(productionItem: ProductionItem) => {
            // const display = buildSimpleQuantityDisplay(calculatedQuantity);
            // const display = buildSimpleQuantityDisplay(getSeedingBatchQuantity(seedingBatch));
            const display = productionItem.orderItem.order.organization.name;
            return display;
          }}
        />
        <Table.Column
          title="Solicitante"
          key="createdBy"
          dataIndex="createdBy"
          // filters={Object.values(OrderTypeEnum).map((orderType) => ({
          //   text: OrderTypeDisplayMapping[orderType].name,
          //   value: orderType,
          // }))}
          // filterMultiple={false}
          // filteredValue={orderTypeFilter !== null ? [orderTypeFilter] : null}
          render={(createdBy: UserProfile) => createdBy.name}
        />
        <Table.Column
          title=""
          key="action"
          dataIndex="id"
          render={(id: string, record: SeedTicket, index: number) => {
            const actionButton = (
              <TableRowAction
                index={index}
                onDetails={onDetailsActionClick}
              />
            );
            return actionButton;
          }}
        />
      </Table>

      <TicketDetailsModal
        item={
          currentActiveRow !== undefined && currentActiveRow >= 0 && incomingTicketList
            ? incomingTicketList[currentActiveRow]
            : undefined
        }
        isVisible={isTicketDetailsModalOpen}
        onCancel={onTicketDetailsModalClosed}
      />
    </>
  );
};

export default ConfirmedTicketsTab;
